import { useModal } from '@/storybook/modal/useModal';
import { useStorage } from '@vueuse/core';
import FirstItemModal from './../components/modal/FirstItemModal.vue';

export const useFirstItemModal = () => {
  const wasClosed = useStorage('first-item-modal-closed', false);

  const open = () => {
    if (wasClosed.value) {
      return;
    }

    const { open, close } = useModal(FirstItemModal, {
      dataTestid: 'first-item-modal',
      customClose: () => {
        wasClosed.value = true;
        close();
      },
    });
    return open();
  };

  return { open, close };
};
